import axios from "axios";

var Default = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    GetForView: function (viewName) {
        return axios.get(Apollo.resolveApiUrl("~/Default/GetForView"), {
            params: {
                view: viewName
            }
        });
    },
    GetForViewNoAuth: function (viewName) {
        return axios.get(Apollo.resolveApiUrl("~/Default/NoAuthGetForView"), {
            params: {
                view: viewName
            }
        });
    },
    Find: function (nameKey, defaultArray) {
        for (var i = 0; i < defaultArray.length; i++) {
            if (defaultArray[i].k === nameKey) {
                //console.log(defaultArray[i].v);
                return defaultArray[i].v;
            }
        }
    }
};
export default Default;



// WEBPACK FOOTER //
// ./src/models/Default.js